module.exports = __webpack_public_path__ + "static/img/feature-circle-two.252bf2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature-circle-two.png
// module id = KZrA
// module chunks = 0